import { useMemo } from "react"
import styled from "styled-components"

import { UITypes } from "types"

import { getDateRangeFromOption } from "utils/dateUtils"
import { DateRangePickerSelect } from "components/common/DateRangePickerSelect"
import { ButtonNew } from "components/form/ButtonNew"
import { dateSelectOptions } from "pages/vendor/Dashboard/constants"

export const calculateLastDays = (days: number) => getDateRangeFromOption(String(days))

const Container = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  border-bottom: 1px solid var(--border-subtle);
`

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

const Title = styled.h3`
  font-family: $secondaryFont;
  font-size: 1rem;
  font-weight: 500;
`

interface WidgetHeaderProps {
  title: string
  buttonText?: string
  onButtonClick?: () => void
  includeCustomRangeSelect?: boolean
  explicitDateSelectOptions?: UITypes.Option[]
  defaultSelectedDateOption?: UITypes.Option
  onSelectDateRange?: (date: [string, string]) => void
  minDate?: string
}

const WidgetHeader = ({
  title,
  buttonText,
  onButtonClick,
  includeCustomRangeSelect,
  explicitDateSelectOptions,
  defaultSelectedDateOption,
  onSelectDateRange,
  minDate,
}: WidgetHeaderProps) => {
  const options = useMemo(
    () =>
      explicitDateSelectOptions || [
        ...dateSelectOptions,
        ...(includeCustomRangeSelect ? [{ label: "Custom", value: "custom" }] : []),
      ],
    [includeCustomRangeSelect, explicitDateSelectOptions],
  )

  return (
    <Container>
      <Title>{title}</Title>
      {(buttonText || onSelectDateRange) && (
        <HeaderActions>
          {buttonText && <ButtonNew onClick={onButtonClick}>{buttonText}</ButtonNew>}
          {onSelectDateRange && (
            <DateRangePickerSelect
              minDate={minDate}
              options={options}
              defaultOption={defaultSelectedDateOption || options[0]}
              onSelectDateRange={onSelectDateRange}
            />
          )}
        </HeaderActions>
      )}
    </Container>
  )
}

export default WidgetHeader
